import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { getLink } from "../../dataProvider/links.js";
import { connect } from 'react-redux'
import { logoutUser } from '../../actions/user.js';
import { getCloudFiles } from '../../actions/file.js';

import convertIconV2 from "../../img/v2/user/convert.png"
import compressIconV2 from "../../img/v2/user/compress-icon.png"
import splitIconV2 from "../../img/v2/user/split-pdf.png"
import convertPictureIconV2 from "../../img/v2/user/convert-picture.png"
import convertEbookIconV2 from "../../img/v2/user/convert-ebook.png"
import convertFontIconV2 from "../../img/v2/user/convert-font.png"
import cloudDownloadIconV2 from "../../img/v2/user/cloud-download-icon.png";
import profileCircleTransparentV2 from "../../img/v2/user/profile-circle-transparent.png";
import profileCircleV2 from "../../img/v2/user/profile-circle-white.png";
import contactV2 from "../../img/v2/user/contact-icon.png";
import exitV2 from "../../img/v2/user/exit.png";
import downloadV2 from "../../img/v2/user/download.png";
import goV2 from "../../img/v2/user/go.png";
import fileConvertedV2 from "../../img/v2/user/file-converted.png";

import moment from 'moment';
import { reloadUser } from '../../actions/user.js';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import useWindowDimensions from '../util/Window.js';

import "../../scss/v2/user/account.scss"

function Account(props) {

    const { t, i18n } = useTranslation();
    const [files, setFiles] = useState([]);
    const [reloadFilesNeeded, setReloadFilesNeeded] = useState(false);
    var navigate = useNavigate();
    var reloadFilesInterval = useRef(null);
    const { width } = useWindowDimensions();

    const reloadFiles = useCallback(async () => {
        const user = await props.dispatch(reloadUser());

        if (!user) {
            setReloadFilesNeeded(false);
            return;
        }
        var availablesConversions = [];
        var isReloadFilesNeedeed = false;

        const cloudFiles = await props.dispatch(getCloudFiles())

        cloudFiles.forEach(cloudFile => {
            switch (cloudFile.status) {
                case 'finished':
                    if (availablesConversions.length < 2) availablesConversions.push({
                        ...cloudFile,
                        fileNameFull: cloudFile.url.split('/').pop(),
                        fileName: shortenedFileName(cloudFile.url.split('/').pop()),
                        format: cloudFile.url.split('.').pop().toUpperCase()
                    });
                    break;

                case 'pending':
                    if (availablesConversions.length > 2) availablesConversions[0] = { ...cloudFile };
                    else availablesConversions.unshift({ ...cloudFile });
                    isReloadFilesNeedeed = true;
                    break;

                default:
                    break;
            }
        })

        availablesConversions.sort((a, b) => {
            if (moment(a.date).isBefore(b.date)) return 1;
            if (moment(a.date).isAfter(b.date)) return -1;
            return 0;
        })

        setReloadFilesNeeded(isReloadFilesNeedeed);
        setFiles(availablesConversions);
    }, [props])

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        if (!props?.user || !props?.user?.connected) return navigate(getLink('login', props.lang));
        i18n.changeLanguage(props.lang);
    }, [props.lang, props.user])


    useEffect(() => {
        if (!props?.user || !props.user.connected) return
        reloadFiles();
    }, []);

    useEffect(() => {
        if (!reloadFilesNeeded) return () => clearInterval(reloadFilesInterval);
        reloadFilesInterval = setInterval(reloadFiles, 2000);
        return () => clearInterval(reloadFilesInterval);
    }, [reloadFilesNeeded]);
    /* eslint-enable */

    const shortenedFileName = (filename) => {
        var extension = '.' + filename.split('.').pop();
        var displayName = filename.substring(0, filename.length - extension.length);

        if (filename.length >= 12) {
            displayName = displayName.substring(0, 3) + "..." + displayName.slice(-3) + extension;
        }

        return displayName;
    }

    const getItemsHeaderMenu = useMemo(() => {
        return [
            {
                overlayText: t('account.cloudCard.title'),
                link: getLink('cloud', i18n.language),
                icon: <img src={cloudDownloadIconV2} alt={t('account.cloudCard.title')} />
            },
            {
                overlayText: t('manageAccount.title'),
                link: getLink('manageAccount', i18n.language),
                icon: <img src={profileCircleTransparentV2} alt={t('manageAccount.title')} />
            },
            {
                overlayText: t('unsubscribe.topCard.title'),
                link: getLink('unsubscribe', i18n.language),
                icon: <img src={contactV2} alt={t('unsubscribe.topCard.title')} />
            },
            {
                overlayText: t('account.overlayText.disconnect'),
                link: () => props.dispatch(logoutUser()),
                icon: <img src={exitV2} alt={"exit"} />,
                isLogOut: true
            }
        ]
    }, [t, i18n.language, props]);


    const getItemsAccountConvertMenu = useMemo(() => {
        return [
            {
                icon: convertIconV2,
                title: t('account.convertCard.title'),
                text: t('account.convertCard.text'),
                link: getLink('home', i18n.language)
            },
            {
                icon: convertFontIconV2,
                title: t('account.convertFontCard.title'),
                text: t('account.convertFontCard.text'),
                link: getLink('convertFONT', i18n.language)
            },
            {
                icon: convertEbookIconV2,
                title: t('account.convertEbookCard.title'),
                text: t('account.convertEbookCard.text'),
                link: getLink('convertEBOOK', i18n.language)
            },
            // {
            //     icon: convertVideoIconV2,
            //     title: "Convert YouTube to MP4",
            //     text: "Convert any video link to MP4",
            //     // link: getLink('convertVIDEO', i18n.language)
            // },
            // {
            //     icon: convertMusicIconV2,
            //     title: "Convert YouTube to MP3",
            //     text: "Convert any video link to MP3",
            //     // link: getLink('convertMUSIC', i18n.language)
            // },
            {
                icon: convertPictureIconV2,
                title: t('account.convertPictureCard.title'),
                text: t('account.convertPictureCard.text'),
                link: getLink('convertIMAGE', i18n.language)
            }
        ]
    }, [t, i18n.language]);

    /* eslint-disable react-hooks/exhaustive-deps */
    const getItemsAccountConvertMenuMobile = useMemo(() => {
        var items = [].concat(getItemsAccountConvertMenu);

        for (const item of [
            {
                icon: compressIconV2,
                title: t('account.compressSeparate.compressCard.title'),
                text: t('account.compressSeparate.compressCard.text'),
                link: getLink('compress', i18n.language)
            },
            {
                icon: splitIconV2,
                title: t('account.compressSeparate.splitCard.title'),
                text: t('account.compressSeparate.splitCard.text'),
                link: getLink('splitPdf', i18n.language)
            }
        ].reverse()) items.unshift(item);

        return items;
    }, [t, i18n.language]);
    /* eslint-enable */

    const overlayObj = (text) => <Tooltip className='tooltip'>{text}</Tooltip>;

    function ProfileAccountHeader({ renderMobile }) {
        return (
            <>
                <div id='account-header'>
                    {renderMobile ? (
                        <div className='account-welcome'>
                            <div id='title'>{t('account.header.hello', "HI")} {props.user.firstName.toUpperCase()}</div>
                            <span>{t('account.header.manageYourAccount', 'Manage your account')}</span>
                        </div>
                    ) : null}
                    <div>
                        <div className='account-image'>
                            <img src={profileCircleV2} alt='profile' />
                        </div>

                        <div className='account-infos'>
                            <span id='names'>{props.user.firstName} {props.user.lastName}</span>
                            <span id='email'>{props.user.email}</span>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    function DesktopRender() {
        return (
            <>
                <div className='account container'>
                    <ProfileAccountHeader />
                    <div id='account-header-buttons'>
                        {getItemsHeaderMenu.map((item, key) => (
                            <OverlayTrigger
                                overlay={overlayObj(item.overlayText)}
                                key={key}
                            >
                                <Link onClick={item?.isLogOut ? item.link : null} to={item?.isLogOut ? null : item.link}>
                                    {item.icon}
                                </Link>
                            </OverlayTrigger>
                        ))}
                    </div>
                </div>

                <div className='container separator' />

                <div className='account container'>
                    <div id='account-mycloud' className='col-12 col-lg-7'>
                        <div id='title'>
                            {t('account.cloudCard.title')}
                        </div>

                        <div>
                            <table>
                                <thead>
                                    <tr>
                                        <th>{t('account.cloudCard.table.fileName', 'Filename')}</th>
                                        <th>{t('account.cloudCard.table.timeConverted', 'Time Converted')}</th>
                                        <th>{t('account.cloudCard.table.convertedTo', 'Converted To')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {files.map((item, key) => (
                                        <tr key={key}>
                                            <td>
                                                {item.status === 'pending' ? (
                                                    <span className='spinner-border' role='status' />
                                                ) : (
                                                    <OverlayTrigger overlay={overlayObj(item.fileNameFull)} placement='right'>
                                                        <span>
                                                            <div><img src={fileConvertedV2} alt='File Converted' /></div>
                                                            {item.fileName}
                                                        </span>
                                                    </OverlayTrigger>
                                                )}
                                            </td>
                                            <td>
                                                {moment(item.date).format('HH:mm DD/MM/YYYY')}
                                            </td>
                                            <td>
                                                {item.status === 'pending' ? (
                                                    <span className='spinner-border' role='status' />
                                                ) : (
                                                    <>
                                                        {item.format}
                                                    </>
                                                )}
                                            </td>
                                            <td>
                                                {item.status === 'pending' ? (
                                                    <span className='spinner-border' role='status' />
                                                ) : (
                                                    <a target='_blank' rel="noreferrer" href={item.url}><img src={downloadV2} alt='download' /></a>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div>
                            <Link to={getLink('cloud', i18n.language)}>
                                <span>{t('account.cloudCard.viewAllFiles', 'VIEW ALL FILES')}</span>
                                <img src={goV2} alt='View all files' />
                            </Link>
                        </div>
                    </div>

                    <div id="account-compress-separate" className='col-12 col-lg-5'>
                        <Link to={getLink('compress', i18n.language)}>
                            <div className='items'>
                                <div>
                                    <img src={compressIconV2} alt='Compress' />
                                </div>

                                <div>
                                    <span id='title'>{t('account.compressSeparate.compressCard.title', 'Compress Files')}</span>
                                    <div>
                                        <span>{t('account.compressSeparate.compressCard.text', 'Manage compressed files easily.')}</span>
                                    </div>
                                </div>

                                <div>
                                    <img src={goV2} alt='Compress button' />
                                </div>
                            </div>
                        </Link>

                        <Link to={getLink('splitPdf', i18n.language)}>
                            <div className='items'>
                                <div>
                                    <img src={splitIconV2} alt='Split' />
                                </div>

                                <div>
                                    <span id='title'>{t('account.compressSeparate.splitCard.title', 'Splitting Your PDF')}</span>
                                    <div>
                                        <span>{t('account.compressSeparate.splitCard.text', 'Splitting your PDF to PDF pages.')}</span>
                                    </div>
                                </div>

                                <div>
                                    <img src={goV2} alt='Split button' />
                                </div>
                            </div>
                        </Link>

                    </div>
                </div>

                <div id="account-convert-menu" className='account container'>
                    <div>
                        {t('account.convert', 'Convert')}
                    </div>

                    <div>
                        {getItemsAccountConvertMenu.map((item, key) => (
                            <div className='items' key={key}>
                                <img src={item.icon} alt={item.title} />
                                <div id="title">
                                    <span>{item.title}</span>
                                </div>
                                <div id="text">
                                    <span >{item.text}</span>
                                </div>
                                <div>
                                    <Link to={item.link}><img src={goV2} alt='Split button' /></Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </>
        )
    }

    function MobileRender() {
        return (
            <>
                <div className='account container'>
                    <ProfileAccountHeader renderMobile />
                </div>

                <div className='account container'>
                    <div id="mobile-recent-file">
                        <div id='title'>
                            {t('account.mobileRecentFiles.title', 'Recent Files')}
                        </div>

                        <div id='item-container'>
                            {files.map((item, key) => (
                                <a target='_blank' rel="noreferrer" href={item.url} key={key}>
                                    <div>
                                        <div>
                                            {item.status === "pending" ? (
                                                <span className='spinner-border' role='status' />
                                            ) : (
                                                <img src={downloadV2} alt='download' />
                                            )}
                                        </div>

                                        <div>
                                            {item.status !== "pending" ? (
                                                item.fileName
                                            ) : null}
                                        </div>
                                    </div>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>

                <div className='account container'>
                    <div id='mobile-convert-menu'>
                        <div id="title">
                            {t('account.mobileConvertMenu.title', "Continue Converting")}
                        </div>

                        <div>
                            {getItemsAccountConvertMenuMobile.map((item, key) => (
                                <div className='item' key={key} onClick={() => navigate(item.link)}>
                                    <div className='item-icon'>
                                        <img src={item.icon} alt='icon' />
                                    </div>

                                    <div className='item-text'>
                                        <div id="title">{item.title}</div>
                                        <div>{item.text}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className='mobile-separator' />

                <div className='account container'>
                    <div id='mobile-base-links'>
                        {getItemsHeaderMenu.map((item, key) => (
                            <div className='item' onClick={() => {
                                if (item?.isLogOut) {
                                    item.link();
                                    navigate(getLink('home', i18n.language))
                                } else navigate(item.link)
                            }}
                            >
                                <div id='item-icon'>
                                    {item.icon}
                                </div>

                                <div id='item-text'>
                                    {item.overlayText}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </>
        )
    }

    return (
        <>
            <div className="account">
                {(width > 992) ? (
                    <DesktopRender />
                ) : (
                    <MobileRender />
                )}
            </div>
        </>
    )
}

const mapStateToProps = state => ({ user: state.user.user, file: state.file });

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(Account);